import React from "react";
import "./newUpdate.css";
import buttonArrow from "assets/realEstateCRM-image/button-arrow.svg";
import securityImg from "assets/realEstateCRM-image/security_img.svg";
import { useNavigate } from "react-router-dom";

const NewUpdate = () => {
  const navigate = useNavigate();

  const handleStartFreeTrail = (e) => {
    e.preventDefault();
    navigate("/choose-plan");
  };

  return (
    <div className="new-update--container">
      <div className="container">
        <div className="new-update--outer">
          <button className="title-button title-button--secondary">New Updates</button>
          <div className="differentiators">
            <h4>Our Key Differentiators</h4>
          </div>
          <div className="new-update--row">
            <div className="new-update--box">
              <h2>Mobile First Solutions</h2>
              <p>
                Superior UX with smarter solution for new age sales requirements
              </p>
            </div>
            <div className="new-update--box">
              <h2>Product Approach</h2>
              <p>
                In line with latest trends and customized as per the sales
                requirement, the product are customized without any additional
                costs.
              </p>
            </div>
            <div className="new-update--box">
              <h2>Endorsed by Users</h2>
              <p>
                With presence across 14 cities in india and GCC, in a span of three
                year, we have executed 300+ project and sold 30,000+ home.
              </p>
            </div>
          </div>
          <div className="newupdate2-row">
            <div className="newupdate1-box">
              <h2>Built for Success</h2>
              <p>
                Powers ANAROCK Residential's operation and business initiatives, we
                are not just building for your but ours too.
              </p>
            </div>
            <div className="newupdate2-box">
              <h4>Let's start your free trial</h4>
              <div onClick={handleStartFreeTrail} className="tcl-button--outer tcl-button--start">
                <button className="tcl-button tcl-button--primary">Start Free Trial</button>
                <div className="realEstateCRM-arrow">
                  <img src={buttonArrow} alt="Start Free Trial" />
                </div>
              </div>
            </div>
          </div>
          <div className="newupdate3-row">
            <div className="newupdate3-box1">
              <div className="security-img--lock">
                <img src={securityImg} alt="Our Solutions" />
              </div>
            </div>
            <div className="newupdate3-box2">
              <button className="title-button title-button--secondary">Our Solutions</button>
              <h4>
                We are committed to ensuring the privacy and security of your data
              </h4>
              <p>
                We prioritize the privacy and security of your data, implementing
                robust measures to protect it from unauthorized access and ensure
                confidentiality at all times. With advanced encryption, secure cloud
                storage, and regular security audits, we ensure that your
                information is safeguarded against potential threats. Trust us to
                handle your data with the highest level of care and security, giving
                you peace of mind as you focus on growing your business.
              </p>
            </div>
          </div>
          <div className="newupdate4-row">
            <div className="newupdate4-box">
              <h2>Infrastructure Security</h2>
              <p>
                Ensure the safety and integrity of your data with advanced
                infrastructure security measures. Our solutions are designed to
                safeguard against vulnerabilities, providing a secure environment
                for your operations.
              </p>
            </div>
            <div className="newupdate4-box">
              <h2>Data Protection</h2>
              <p>
                Protect your data from unauthorized access, breaches, and cyber
                threats. With advanced security measures, ensure your information
                remains safe, private, and exclusively yours.
              </p>
            </div>
            <div className="newupdate4-box">
              <h2>Information Governance</h2>
              <p>
                Implement structured policies and procedures to manage your
                information effectively. Ensure data accuracy, compliance, security,
                and accessibility, empowering informed decision-making and
                operational excellence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUpdate;
